<div>
    {{data.message}}
</div>
<div>
    <button class="snackbar-buttons" *ngFor="let action of data.actions" mat-button matSnackBarAction (click)="actionClick(action)">{{action}}</button>
</div>